import * as $ from 'jquery';
import { disposable, serialDisposable, disposableSubscription } from 'common/barrels/core';

import { undefinedNullOrEmpty } from 'common/functions/string';

import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';

import 'runtime/styles/controls/videocontrol.less';

export class VideoControl extends Control {
    private videoDisposable = serialDisposable(null);
    private videoLoaded = false;
    private $video;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container videocontrol');

        if (!undefinedNullOrEmpty(this.config.source))
            this.source(this.config.source);

        this.subscriptions = disposableSubscription(
            this.processBindings(this.config)
        );

        this.applyTooltip(this.$element);

        this.initialize();
    }

    dispose() {
        super.dispose();
        this.videoDisposable.dispose();
    }

    private loadVideo(value: string) {
        this.videoLoaded = false;
        var $video = $('<video width="100%" height="100%" />').appendTo(this.$element);

        $video
            .on('canplay', () => {
                $video.show();
                this.videoLoaded = true;
            })
            .on('error', () => {
                this.triggerEvent('VideoError');
            })
            .on('ended', () => this.triggerEvent('VideoFinished'))
            .prop('src', '../../' + value)
            .hide()
            ;

        this.$video = $video;

        this.videoDisposable.set(disposable(() => {
            $video.remove();
            this.$video = null;
        }));
    }

    private ifVideoLoaded(lambda: () => void) {
        if (this.$video && this.videoLoaded)
            lambda();
    }

    source(value) {            
        this.videoDisposable.set(null);

        if (value)
            this.loadVideo(value);
    }

    play() {
        this.ifVideoLoaded(() => this.$video[0].play());
    }

    stop() {
        this.ifVideoLoaded(() => {
            this.pause();
            this.reset();
        });
    }

    reset() {
        this.ifVideoLoaded(() => this.$video[0].currentTime = 0);
    }

    pause() {
        this.ifVideoLoaded(() => this.$video[0].pause());
    }

    togglePlayPause() {
        this.ifVideoLoaded(() => {
            if (this.$video[0].paused)
                this.play();
            else
                this.pause();
        });
    }

    skipTo(seconds) {
        this.ifVideoLoaded(() => this.$video[0].currentTime = +seconds);
    }

    skipForward(seconds) {
        this.ifVideoLoaded(() => this.$video[0].currentTime = this.$video[0].currentTime + +seconds);
    }

    skipBackward(seconds) {
        this.ifVideoLoaded(() => this.$video[0].currentTime = this.$video[0].currentTime - +seconds);
    }
}

registerBinding('videocontrol', VideoControl);